import React, { useEffect } from "react";
import { ColorPicker, Flex, Input, InputProps } from "antd";
import { observer } from "mobx-react-lite";
import { validateHex, validateRgb } from "src/common/attrEdit";
import { ColorCardStore } from "./ColorCardStore";
import styles from "./ColorCard.module.less";

type PropsColorCard = Omit<InputProps, "onChange" | "value"> & {
  store: ColorCardStore;
  value?: string[] | null;
  onChange?(newValue?: string[] | null): void;
  height?: number;
};

export const ColorCard: React.FC<PropsColorCard> = observer(
  ({ store, value, onChange, height, ...rest }) => {
    const { format } = store;
    const colorValue = value?.[0];
    const showPreview =
      !!colorValue && (validateHex(colorValue) || validateRgb(colorValue));
    useEffect(() => {
      store.validateFormat(colorValue);
    }, [colorValue]);
    return (
      <Flex vertical gap={8}>
        <ColorPicker
          value={colorValue}
          onFormatChange={(val) => store.setFormat(val)}
          onChange={(val) => onChange?.(store.getFormattedValue(val))}
          disabledAlpha
          format={format ?? undefined}
        >
          <Input
            {...rest}
            value={colorValue}
            onChange={(e) => onChange?.([e.currentTarget.value ?? ""])}
          />
        </ColorPicker>
        {showPreview && (
          <div
            style={{
              height: height ?? 400,
              backgroundColor: colorValue,
            }}
            className={styles.preview}
          />
        )}
      </Flex>
    );
  },
);
